import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { GrooveActionDirective, GrooveHeroComponent } from '@groove/angular';
import { SectionHeadComponent } from '../../../content/section-head/section-head.component';
import { DATA_CONFIG } from '../../../injection-tokens';
import { SEOService } from '../../../seo.service';
import { HubBodyComponent } from '../hub-body/hub-body.component';
import { buildHomePageSchemas } from './home-jsonld';

/**
 * Home IS the online-lessons hub (spec §4): the stage hero holds the page's
 * single <h1>, <app-hub-body> carries the eight-beat story, and the
 * Russ-the-player band is projected into hub-body's [data-slot=band] slot
 * between the FAQ and "Getting set up". Breadcrumb trail and the For-students
 * block are the shell's (app.component.html), not this template's.
 */
@Component({
  selector: 'app-home-content',
  imports: [
    RouterLink,
    GrooveActionDirective,
    GrooveHeroComponent,
    HubBodyComponent,
    SectionHeadComponent,
  ],
  templateUrl: './home-content.component.html',
  styleUrl: './home-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeContentComponent implements OnDestroy {
  private readonly dataConfig = inject(DATA_CONFIG);
  private seo = inject(SEOService);
  protected readonly phoneHref = this.dataConfig.phoneHref;
  protected readonly emailHref = this.dataConfig.emailHref;

  constructor() {
    // No route param to react to, so a plain constructor call is enough —
    // this page's JSON-LD never changes after mount. Sets the Course +
    // FAQPage + VideoObject schemas that used to live in app.routes.ts's
    // static data.seo.jsonLd (evaluated eagerly at bootstrap); see
    // home-jsonld.ts for why this moved.
    this.seo.setRouteSchemas(buildHomePageSchemas());
  }

  ngOnDestroy(): void {
    this.seo.clearRouteSchemas();
  }
}
